import { db } from '../firebase';
import { collection, doc, addDoc, getDocs, query, where, writeBatch, serverTimestamp } from 'firebase/firestore';
import { LaborRecord } from '../types';
import Papa from 'papaparse';
import { getStaff } from './staffService';

export const saveLaborRecords = async (tenantId: string, records: LaborRecord[]) => {
  const batch = writeBatch(db);
  records.forEach(record => {
    const ref = doc(collection(db, 'tenants', tenantId, 'labor_records'));
    batch.set(ref, { 
      ...record, 
      createdAt: serverTimestamp() 
    });
  });
  await batch.commit();
};

export const getLaborRecords = async (tenantId: string, date: string, shiftName?: string): Promise<LaborRecord[]> => {
  const laborRef = collection(db, 'tenants', tenantId, 'labor_records');
  let q = query(laborRef, where('date', '==', date));
  if (shiftName) {
    q = query(q, where('shiftName', '==', shiftName));
  }
  
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as LaborRecord));
};

export const getLaborRecordsByStaffId = async (tenantId: string, staffId: string): Promise<LaborRecord[]> => {
  const laborRef = collection(db, 'tenants', tenantId, 'labor_records');
  const q = query(laborRef, where('staffId', '==', staffId));
  try {
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as LaborRecord));
  } catch (error) {
    console.error('Error fetching labor records by staffId:', error);
    return [];
  }
};

export const importLaborFromCSV = async (tenantId: string, file: File): Promise<number> => {
  const staffList = await getStaff(tenantId);
  
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      delimiter: ",",
      complete: async (results) => {
        const records: LaborRecord[] = [];
        for (const row of results.data as any[]) {
          const date = row['Date'] || row['Tip Date'] || '';
          const posId = row['POS_ID'] || row['Staff ID'] || '';
          const shiftName = row['Shift'] || '';
          const hours = Number(row['Hours'] || row['Hours Worked'] || 0);

          if (!date || !posId || hours <= 0) continue;

          const staff = staffList.find(s => s.posId === posId);
          if (!staff) continue;

          records.push({
            tenantId,
            staffId: staff.id!,
            staffName: staff.name,
            date,
            shiftName,
            startTime: row['Start'] || '',
            endTime: row['End'] || '',
            hoursWorked: hours
          });
        }
        
        if (records.length > 0) {
          await saveLaborRecords(tenantId, records);
        }
        resolve(records.length);
      },
      error: reject
    });
  });
};
